import React from "react";
// Update these paths based on your actual file locations:
import imgPAA from "../assets/personal_assistant_agent.png";
import imgResume from "../assets/resume_analyzer.png";
import imgTask from "../assets/task_scheduler.png";

function ProjectCard() {
  const projects = [
    {
      title: "JobFit AI",
      description:
        "An AI powered Resume and JD match analyzer with additional Job opening insights to help you prepare best for the job opening.",
      img: imgResume,
      link: "https://github.com/Matvibhor24",
    },
    {
      title: "Share of Voice Market Research Agent",
      description:
        "A Python-based AI agent that analyzes a company's online presence for any of its products across Google and YouTube. The agent computes Share of Voice (SoV), Share of Positive Voice (SPV), engagement metrics, and generates actionable insights for marketing teams. Built with LangGraph nodes, VADER sentiment analysis, and LLM integration for insights",
      img: imgTask,
      link: "https://github.com/Matvibhor24",
    },
    {
      title: "Personal Assistant",
      description:
        "This application creates an AI-powered agent that can read and respond to your WhatsApp messages, perform web searches, and provide helpful information using Google's free Gemini models.",
      img: imgPAA,
      link: "https://github.com/Matvibhor24",
    },
  ];

  return (
    <div
      className="project-card-container"
      style={{
        background: "#fff",
        borderRadius: "28px",
        maxWidth: 680,
        width: "99%",
        boxShadow: "0 4px 24px rgba(80,80,120,0.13)",
        padding: "40px 2vw 30px 2vw",
        margin: "0 auto",
        textAlign: "left",
        position: "relative",
      }}
    >
      <div
        style={{
          fontSize: 28,
          fontWeight: 700,
          marginBottom: 22,
          letterSpacing: -1,
        }}
      >
        My Projects
      </div>
      <div
        className="project-list-container"
        style={{
          display: "flex",
          overflowX: "auto",
          gap: 18,
          paddingBottom: 8,
        }}
      >
        {projects.map(({ title, description, img, link }) => (
          <a
            className="project-card-link"
            key={title}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              minWidth: 170,
              maxWidth: 180,
              flex: "0 0 170px",
              background: "#f8f8fa",
              borderRadius: 16,
              boxShadow: "0 2px 10px rgba(60,62,115,0.07)",
              border: "1.5px solid #f0f0f0",
              textDecoration: "none",
              color: "#131313",
              transition: "box-shadow 0.2s",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src={img}
              alt={title}
              style={{
                width: "100%",
                height: 115,
                objectFit: "cover",
                borderRadius: "16px 16px 0 0",
                marginBottom: 0,
              }}
            />
            <div
              style={{
                fontWeight: 700,
                fontSize: "1rem",
                margin: "10px 0 2px 0",
                textAlign: "center",
              }}
            >
              {title}
            </div>
            <div
              style={{
                fontSize: ".89rem",
                color: "#5b5b5b",
                textAlign: "center",
                padding: "0 10px 13px 10px",
              }}
            >
              {description}
            </div>
          </a>
        ))}
      </div>
      <div
        style={{
          fontSize: ".96rem",
          color: "#333",
          marginTop: 18,
          lineHeight: 1.5,
        }}
      >
        <b>JobFit AI</b> — AI-powered resume and JD match analyzer with rich job
        insights to help you prepare strategically for each role.
        <br />
        <b>Share of Voice Market Research Agent</b> — Automated share-of-voice
        and sentiment analysis across Google and YouTube to generate marketing
        insights.
        <br />
        <b>WhatsApp Personal Assistant Agent</b> — AI agent that reads and
        responds to WhatsApp messages, performs web searches, and answers using
        Gemini models.
      </div>
    </div>
  );
}

export default ProjectCard;
